import { SmartLink } from "../../fragments/smart-link/SmartLink";

import { motion } from "motion/react";

export default function Breadcrumb({ parents }) {
  // if (!parents) return null;

  const breadcrumbItems = parents
    ? [
        {
          title: "Home",
          uri: "/",
          slug: "home",
        },
        ...[...parents].reverse(),
      ]
    : [];

  return (
    <motion.nav
      className="Breadcrumb"
      aria-label="Breadcrumb navigation"
      initial={{ opacity: 0, y: "10px" }}
      animate={{ opacity: 1, y: "0px" }}
      transition={{ type: "spring", duration: 0.7, delay: 0.9 }}
    >
      {breadcrumbItems.map((item, index) => (
        <SmartLink href={item.uri} className="label--size-xs" key={index}>
          <span>{item.title}</span>
        </SmartLink>
      ))}
    </motion.nav>
  );
}
